var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "wa-modal-frame",
    {
      attrs: {
        "is-showing": _vm.isShowing,
        "has-sections": false,
        title: `You need a ${_vm.upsellRequirement} for that!`,
        "component-class": "upsell",
        "has-actions": "",
      },
      on: {
        "close-modal": function ($event) {
          return _vm.$emit("close-modal")
        },
      },
    },
    [
      _vm._t("upsell-description", function () {
        return [
          _c("p", { staticClass: "line-length-xl margin-bottom-xl" }, [
            _c(
              "span",
              { staticClass: "size-lg" },
              [
                _vm.upsellTriggerIconName
                  ? _c("font-awesome-icon", {
                      staticClass: "margin-right-5xs",
                      attrs: {
                        icon: _vm.$v6[_vm.upsellTriggerIconStyle][
                          _vm.upsellTriggerIconName
                        ],
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("strong", [_vm._v(_vm._s(_vm.upsellTrigger))]),
                _vm._v(
                  " requires a " + _vm._s(_vm.upsellRequirement) + ".\n      "
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "size-lg" },
              [
                _vm._v(
                  "Here are some of our popular plans that will get you access, or you can\n        "
                ),
                _c(
                  "site-link",
                  {
                    staticClass: "no-underline",
                    attrs: { to: { name: "plans" } },
                    nativeOn: {
                      click: function ($event) {
                        return _vm.$posthog.capture("view_plans_button_click", {
                          context: "upsell_modal",
                          feature: _vm.upsellTriggerSlug,
                        })
                      },
                    },
                  },
                  [_vm._v("view all our plans")]
                ),
                _vm._v("."),
              ],
              1
            ),
          ]),
        ]
      }),
      _vm._v(" "),
      _vm._t("upsell-options", function () {
        return [
          _c("upsell-options", {
            attrs: {
              icon: _vm.icon,
              "is-custom-icon": _vm.isCustomIcon,
              "upsell-trigger-slug": _vm.upsellTriggerSlug,
              "upsell-trigger": _vm.upsellTrigger,
            },
          }),
        ]
      }),
      _vm._v(" "),
      _c("template", { slot: "actions" }, [
        _c(
          "div",
          {
            staticClass:
              "row size-sm muted align-center tablet:align-start tablet:text-left",
          },
          [
            _c("div", { staticClass: "column-12 tablet:column-6" }, [
              !_vm.isSignedIn
                ? _c(
                    "p",
                    [
                      _vm._v(
                        "\n          Already have a Pro plan?\n          "
                      ),
                      _c(
                        "site-link",
                        {
                          staticClass: "no-underline",
                          attrs: {
                            to: {
                              name: "sessions.sign-in",
                              query: { next: _vm.signInNext },
                            },
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.$posthog.capture(
                                "sign_in_button_click",
                                {
                                  context: "upsell_modal",
                                  feature: _vm.upsellTriggerSlug,
                                }
                              )
                            },
                          },
                        },
                        [_vm._v("\n            Sign in\n          ")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                class: [
                  "column-12 tablet:column-6 tablet:text-right",
                  { "margin-top-md tablet:margin-top-0": !_vm.isSignedIn },
                ],
              },
              [
                _c(
                  "p",
                  [
                    _c(
                      "site-link",
                      {
                        staticClass: "no-underline",
                        attrs: { to: { name: "plans" } },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.$posthog.capture(
                              "view_plans_button_click",
                              {
                                context: "upsell_modal",
                                feature: _vm.upsellTriggerSlug,
                              }
                            )
                          },
                        },
                      },
                      [_vm._v("View all plans and details")]
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }